<template lang="">
  <div class="offcanvas offcanvas-bottom action-sheet inset" tabindex="-1" :id="'actionSheetContent_' + data">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title fw-bolder">
          خرید اشتراک
        </h5>
        <a
          href="#"
          :id="'offPardakht_' + data"
          class="offcanvas-close"
          style="display: none"
          data-bs-dismiss="offcanvas">
          <ion-icon name="close-outline"></ion-icon>
        </a>
      </div>
      <div class="offcanvas-body">
        <div class="action-sheet-content">
          <p>تعداد تماس های رایگان شما به اتمام رسیده است.</p>
          <p>با خرید اشتراک می توانید به صورت نامحدود با صاحبان بار ایران ترابر تماس بگیرید.</p>
          <div>
            <p class="text-center fw-bolder">پرداخت از طریق درگاه امن بانکی</p>
            <p>
              <a :href="'https://dashboard.iran-tarabar.ir/payDriver/monthly/' + driver_id
                " class="btn background-BRNZ text-light btn-block box-shadow-peyment">1 ماهه {{ formatPrice(price.monthly) }} تومان</a>
            </p>
            <p>
              <a :href="'https://dashboard.iran-tarabar.ir/payDriver/trimester/' + driver_id
                " class="btn background-SILVER text-dark btn-block box-shadow-peyment">3 ماهه {{ formatPrice(price.trimester) }} تومان</a>
            </p>
            <p>
              <a :href="'https://dashboard.iran-tarabar.ir/payDriver/sixMonths/' + driver_id
                " class="btn background-GOLD text-dark btn-block box-shadow-peyment">6 ماهه {{ formatPrice(price.sixMonths) }} تومان</a>
            </p>
          </div>
          

          <!-- <p class="text-success">
            یا به شماره زیر واریز و سپس از طریق دکمه تماس برای فعال سازی با
            ایران ترابر تماس بگیرید.
          </p> -->
          <div>
            <p class="text-center fw-bolder">پرداخت از طریق کارت به کارت</p>
            <div class="peyment-cart">
                <button class="btn" @click="copy()"><ion-icon name="copy-outline"></ion-icon> کپی </button> <ion-icon v-show="check==1" name="checkmark-outline"></ion-icon>
                <div class="mb-2 text-center">
                  <h4 >زرین ترابر فناور گستر</h4> 
                  <span class="mb-2 text-cart-number">
                    ۶۱۰۴-۳۳۸۸-۰۰۴۵-۵۱۷۸
                  </span>
                </div>
                
            </div>
          </div>
          <p class="text-center">پس از واریز برای فعالسازی با پشتیبانی تماس بگیرید.</p>
          
          <a :href="'tel:' + tel" class="btn background-TEAL text-light btn-block">تماس با پشتیبانی</a>
        </div>
      </div>
    </div>
</template>
<script>
import axios from 'axios';


export default {
props: ['driver_id', 'data'],
data() {
  return {
    tel: window.localStorage.getItem("tel"),
    check: 0,
    axiosConfig: {
      headers: {
        'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
        'Accept': 'application/json'
      }
    },
    price: {
      monthly: '135000',
      trimester: '350000',
      sixMonths: '700000',
    },
  }
},
methods: {
  getPrice() {
    axios.get("https://core.iran-tarabar.ir/api/driver/getPackagesInfo", this.axiosConfig)
      .then((response) => {
        this.price.monthly = response.data.data.monthly.price;
        this.price.trimester = response.data.data.trimester.price;
        this.price.sixMonths = response.data.data.sixMonths.price;
      });
  },
  formatPrice(value) {
    let val = (value / 1).toFixed(0).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  copy() {
    navigator.clipboard.writeText('6104338800455178');
    this.check = 1;
    setTimeout(() => {
      this.check = 0;
    }, 2000);
  }
},
mounted() {
  this.getPrice();
}
}
</script>
<style>
.peyment-cart {
border: 1px solid;
border-radius: 10px;
margin-bottom: 9px;
}

.btn-peyment-copy {
border-color: #d9d9d9;
}

.text-cart-number {
font-weight: 800;
font-size: 20px
}
</style>